import { sortByDate } from "@/functions/sortByDate";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "../../.sourceflow/event.json";

export const useEvent = ({ limit = null } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(data.category_values || []), "date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useEvent;
